import { createBrowserHistory } from 'history';

/**
 * Singleton instance of createBrowserHistory() shared as single-spa browser module.
 *
 * We can use this to use navigation in saga, for example.
 */
const history = createBrowserHistory();

export default history;
